import React from 'react'

export default function TermsCondition() {
  return (
    <div>TermsCondition</div>
  )
}
